import * as React from "react"
import {CascaderAjaxSeeker} from "@ui-seeker/core"

import {WEBBACK_V2_API} from "@constants";
import {category} from "@signals";


export default function CommonFiltersCategory({ filters={}, ...props }) {

	return <CascaderAjaxSeeker
		multiple
		urlAjax={`${WEBBACK_V2_API}/master-data/category/options`}
		filters={filters}
		label="Category"
		value={category.value}
		placeholder="All categories"
		onChange={newValue => category.value = newValue}
		menuWidth={300}
		placement="leftStart"
		{...props}
	/>
}